import styled, { css, keyframes } from "styled-components";
const fadeInAnim = keyframes`
  0%{
    animation-timing-function:cubic-bezier(0.17, 0.17, 0.2, 1);
    transform: translateX(25px);
    opacity:0
  }
  55%{
    opacity:1
      }
  100%{
    transform: translateX(0);
    opacity:1
    
  }
`;
const fadeIn = css`
  ${fadeInAnim} 400ms forwards   cubic-bezier(0.17, 0.17, 0.2, 1);
`;
export const Swiper = styled.div`
  position: absolute;
  display: flex;
  cursor: pointer;
  /* transition: transform 0.2s linear; */
  -webkit-font-smoothing: subpixel-antialiased;
  -webkit-transform: translateZ(0) scale(1, 1);

  left: 230px;
  transition: transform 0.5s cubic-bezier(0.17, 0, 0.83, 1);
  transform: ${(p) => "translateX(" + p.n * -150 + "px)"};
  div {
    transition: all 0.5s cubic-bezier(0.17, 0.44, 0.14, 1);
    width: 150px;
    text-align: center;
    -webkit-font-smoothing: subpixel-antialiased;
    -webkit-transform: translateZ(0) scale(1, 1);
  }
  div:nth-of-type(${(p) => p.n}) {
    color: #ffb100;
  }
  div:nth-of-type(1) {
    animation: ${fadeIn};
    transform: translateX(25px);
    opacity: 0;
  }
  div:nth-of-type(2) {
    animation: ${fadeIn};
    animation-delay: 100ms;
    transform: translateX(25px);
    opacity: 0;
  }
`;
